module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-400-192.49d10fd.woff2";